document.addEventListener('DOMContentLoaded', () => {
  const accordions = document.querySelectorAll('.section-accordion-image');

  accordions.forEach((accordion) => {
    const images = accordion.querySelectorAll('.accordion-image');
    const contents = accordion.querySelectorAll('.accordion-content__inner');
    const totalItems = Math.min(images.length, contents.length);
    let currentIndex = 0;
    const titles = accordion.querySelectorAll('.accordion-title');

    function updateActiveClass() {
      images.forEach((img, index) => {
        img.classList.toggle('active', index === currentIndex);
      });
      contents.forEach((content, index) => {
        content.classList.toggle('active', index === currentIndex);
      });
    }

    // Initialize active class on the first item
    updateActiveClass();

    titles.forEach((title, index) => {
      title.addEventListener('click', () => {
        currentIndex = index % totalItems;
        updateActiveClass();
      });
    });
  });
});
